module.exports = __webpack_public_path__ + "static/creative-selection-f59cad646916d96b8a0bd9b41a58e90d.jpg";